import React from 'react';
import { arrayOf, bool, func, node, object, shape, string } from 'prop-types';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockBuilder from '../../BlockBuilder';

import SectionContainer from '../SectionContainer';

import css from './SectionFeatures.module.css';

import video from '../../../../assets/LULO-Home-Header.mp4';
import HowItWorks from '../../../../assets/LULO-how-it-works_CTA.mp4';
import HowItWorksShopper from '../../../../assets/LULO_HowItWorks_Shoppers_CTA.mp4';
import HowItWorksMerchant from '../../../../assets/LULO_HowItWorks_Merchants_CTA.mp4';
import GetYour from '../../../../assets/happy-young-married-couple-shopping-online-choosin-2024-02-15-00-41-51-utc.mp4'

// Section component that shows features.
// Block content are shown in a row-like way:
// [image] text
// text [image]
// [image] text
const SectionFeatures = props => {
  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    blocks,
    isInsideContainer,
    options,
  } = props;

  // If external mapping has been included for fields
  // E.g. { h1: { component: MyAwesomeHeader } }
  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);
  const hasBlocks = blocks?.length > 0;

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={defaultClasses.sectionDetails}>
          <Field data={title} className={defaultClasses.title} options={fieldOptions} />
          <Field data={description} className={defaultClasses.description} options={fieldOptions} />
          <Field data={callToAction} className={defaultClasses.ctaButton} options={fieldOptions} />
          {sectionId == "hero" ?
          <video id="background-video" autoPlay loop muted>
            <source src={video} type="video/mp4" />
            <source src={video} type="video/ogg" />
          </video> : null}
           {sectionId == "get-your-scroll-on-second" ?
          <video id="background-video" autoPlay loop muted>
            <source src={GetYour} type="video/mp4" />
            <source src={GetYour} type="video/ogg" />
          </video> : null}
          {sectionId == "lets-get-this" ?
          <video id="background-video" autoPlay loop muted>
            <source src={HowItWorks} type="video/mp4" />
            <source src={HowItWorks} type="video/ogg" />
          </video> : null}
          {sectionId == "get-your-scroll-on" ?
          <video id="background-video" autoPlay loop muted>
            <source src={HowItWorksShopper} type="video/mp4" />
            <source src={HowItWorksShopper} type="video/ogg" />
          </video> : null}
          {sectionId == "marketplace-possibilities" ?
          <video id="background-video" autoPlay loop muted>
            <source src={HowItWorksMerchant} type="video/mp4" />
            <source src={HowItWorksMerchant} type="video/ogg" />
          </video> : null}
        </header>
      ) : null}
      {hasBlocks ? (
        <div
          className={classNames(defaultClasses.blockContainer, css.featuresMain, {
            [css.noSidePaddings]: isInsideContainer,
          })}
        >
          <BlockBuilder
            rootClassName={css.block}
            ctaButtonClass={defaultClasses.ctaButton}
            blocks={blocks}
            responsiveImageSizes="(max-width: 767px) 100vw, 568px"
            options={options}
          />
        </div>
      ) : null}
    </SectionContainer>
  );
};

const propTypeOption = shape({
  fieldComponents: shape({ component: node, pickValidProps: func }),
});

SectionFeatures.defaultProps = {
  className: null,
  rootClassName: null,
  defaultClasses: null,
  textClassName: null,
  title: null,
  description: null,
  appearance: null,
  callToAction: null,
  blocks: [],
  isInsideContainer: false,
  options: null,
};

SectionFeatures.propTypes = {
  sectionId: string.isRequired,
  className: string,
  rootClassName: string,
  defaultClasses: shape({
    sectionDetails: string,
    title: string,
    description: string,
    ctaButton: string,
  }),
  title: object,
  description: object,
  appearance: object,
  callToAction: object,
  blocks: arrayOf(object),
  isInsideContainer: bool,
  options: propTypeOption,
};

export default SectionFeatures;
